exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bn-input-label[data-v-a3c418d6]{font-size:17px}.fade-enter-active[data-v-a3c418d6],.fade-leave-active[data-v-a3c418d6]{transition:opacity .5s}.fade-enter[data-v-a3c418d6],.fade-leave-to[data-v-a3c418d6]{opacity:0}@media only screen and (max-width:960px){.input-wrapper[data-v-a3c418d6]{flex-direction:column}}.separate-label[data-v-a3c418d6]{height:56px;display:inline-flex;align-items:center;padding-right:16px}.suffix[data-v-a3c418d6]{margin-top:3px}", ""]);

// exports
